//PC端物流说明
"use client";
import React, { useEffect, useMemo, useState } from "react";
import stl from "./delivey.module.scss";
import { getAd } from "@/src/models/loginModel";
import { useCommonContext } from "@/src/provider";
import classnames from "classnames";
import { FmIcon, FmImage, FmPopover } from "@/ui-component";
import variable from "@/src/styles/variables.module.scss";
import { EIconType } from "@/public/static/interface";
import { useTranslation } from "@/src/i18n/client";
interface Props {
    H5Logistics?: any;
}

export interface IStep {
    label: string;
    description: React.ReactNode;
    icon: EIconType;
}
interface IDeleveyProps {
    steps: IStep[];
}
const DeliveyStep: React.FC<IDeleveyProps> = (props) => {
    return (
        <div className={stl["stepper"]}>
            {props.steps.map((item) => {
                return (
                    <div key={item.label} className={stl["step"]}>
                        <div className={classnames(stl["label-container"])}>
                            <FmIcon
                                icon={item.icon}
                                className={stl["step-icon"]}
                            />
                            <p className={stl["label"]}>{item.label}</p>
                        </div>
                        <div className={stl["content"]}>
                            <div className={stl["bar"]}></div>
                            {item.description}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
const Delivey: React.FC<Props> = (props) => {
    const [shippedImg, setShippedImg] = useState("");
    const [deliveyImg, setDeliveyImg] = useState("");
    useEffect(() => {
        !props.H5Logistics &&
            getAd("78,79").then((data: any) => {
                if (!data) {
                    return;
                }
                let img = data[0] ? data[0].img : "";
                let img1 = data[1] ? data[1].img : "";
                setShippedImg(img ?? "");
                setDeliveyImg(img1 ?? "");
            });
    }, [props.H5Logistics]);
    const { host, site } = useCommonContext();
    const { t } = useTranslation("common");

    const processingTime = useMemo(() => {
        return (
            <div className={stl["process"]}>
                <span>{t("common:processingTime")}</span>
                <p>
                    <span style={{ marginRight: "0.1rem" }}>
                        {props.H5Logistics
                            ? props.H5Logistics.process
                            : t("common:DeliveredTime")}
                    </span>
                    <FmPopover
                        buttonProps={{
                            variant: "text",
                            buttonColor: variable.primaryColor,
                            className: stl["popover-button"],
                        }}
                        button={t("common:details")}
                    >
                        <div className="hover-img">
                            <FmImage
                                image={
                                    props.H5Logistics
                                        ? props.H5Logistics.processimg
                                        : shippedImg
                                }
                                width={330}
                            />
                        </div>
                    </FmPopover>
                </p>
            </div>
        );
    }, [props.H5Logistics, shippedImg, t]);

    const shippedTime = useMemo(() => {
        return (
            <div className={stl["process"]}>
                <span>{t("common:shippingTime")}</span>
                <p>
                    <span style={{ marginRight: "0.1rem" }}>
                        {props.H5Logistics
                            ? props.H5Logistics.transport
                            : site === "cl"
                              ? "5-17 días hábiles"
                              : t("common:DeliveredTime2")}
                    </span>
                    <FmPopover
                        buttonProps={{
                            variant: "text",
                            buttonColor: variable.primaryColor,
                            className: stl["popover-button"],
                        }}
                        button={t("common:details")}
                    >
                        <div className="hover-img">
                            <FmImage
                                image={
                                    props.H5Logistics
                                        ? props.H5Logistics.transportimg
                                        : deliveyImg
                                }
                                width={330}
                            />
                        </div>
                    </FmPopover>
                </p>
            </div>
        );
    }, [deliveyImg, props.H5Logistics, site, t]);
    const stepsList = useMemo<IStep[]>(
        () => [
            {
                label: t("common:OrderPlaced"),
                description: processingTime,
                icon: "icon--list",
            },
            {
                label: t("common:Shipped"),
                description: shippedTime,
                icon: "icon--track",
            },
            {
                label: t("common:Delivered"),
                description: <></>,
                icon: "icon-wancheng",
            },
        ],
        [processingTime, shippedTime, t],
    );
    return (
        <div className={stl["delivey-container"]}>
            <DeliveyStep steps={stepsList} />
        </div>
    );
};

export default Delivey;
